<template>
  <div class="mt-5">
  <div class="wrap mt-5">
    <div v-if="timeMsg == ''" class="d-flex flex-column align-items-center cards" style="max-width:1000px">
      <div class="w-100 lanWrap">
        <span class="lanBox" :class="{'active' : currentMsg == 'twd'}"
         @click="currentMsg='twd'">
          中文
        </span>
        <span class="lanBox" :class="{'active' : currentMsg == 'vnd'}"
         @click="currentMsg = 'vnd'">
          Tiếng Việt
        </span>
      </div>
      <h4 class="tit1 text-primary mr-0 text-center">{{returnLag(1)}}</h4>
        <p class="t1 w-100 mb-1">{{ returnLag(2) }}</p>
        <p class="t1 w-100 mb-1">{{ returnLag(3) }}</p>
      <div class="row inputWrap">
        <div  class="col-12 d-flex liss">
          <h6 class="text-right d-flex flex-wrap-wrap h6T my-2 border-b">
            <p style="white-space:nowrap" class="text-primary">{{returnLag(6)}}</p>
            <p class="text-left w-100 pl-5">
              {{ order.transaction_id }}
            </p>
          </h6>
        </div>
        <div  class="col-12 d-flex liss">
          <h6 class="text-right d-flex flex-wrap-wrap h6T my-2 border-b">
            <p style="white-space:nowrap" class="text-primary">{{returnLag(28)}}(VND)</p>
            <p class="text-left w-100 pl-5">
              ₫{{ order.bill_price | vnthousands}}
            </p>
          </h6>
        </div>
        <div  class="col-12 d-flex liss">
          <h6 class="text-right d-flex flex-wrap-wrap h6T my-2 border-b">
            <p style="white-space:nowrap" class="text-primary">{{returnLag(9)}}(TWD)</p>
            <p class="text-left w-100 pl-5" style="font-size:20px">
              ${{ order.real_price | thousands}} <span v-if="order.rate">(1 : {{order.rate}})</span>
            </p>
          </h6>
        </div>
        <div  class="col-12 d-flex liss">
          <h6 class="text-right d-flex flex-wrap-wrap h6T my-2 border-b">
            <p style="white-space:nowrap" class="text-primary">{{returnLag(10)}}</p>
            <p class="text-left w-100 pl-5">
              {{order.bank_from ? 'ATM' : order.bank_name   + returnLag(27)}}
            </p>
          </h6>
        </div>
        <div  class="col-12 d-flex liss" v-if="order.bank_from">
          <h6 class="text-right d-flex flex-wrap-wrap h6T my-2 border-b">
            <p style="white-space:nowrap" class="text-primary">{{returnLag(11)}}</p>
            <p class="text-left w-100 pl-5 ">
              {{ order.bank_from }}
            </p>
          </h6>
        </div>
        <div  class="col-12 d-flex liss" v-if="order.bank_from">
          <h6 class="text-right d-flex flex-wrap-wrap h6T my-2 border-b">
            <p style="white-space:nowrap" class="text-primary">{{returnLag(12)}}</p>
            <p class="text-left w-100 pl-5">
               {{ order.bank_no.replace(/-/g,'') }}
               <button class="btn" v-clipboard:success="onCopy" v-clipboard:copy="order.bank_no.replace(/-/g,'')">{{ returnLag(13) }}</button>
            </p>
          </h6>
        </div>
        <div  class="col-12 d-flex liss" v-if="!order.bank_from">
          <h6 class="text-right d-flex flex-wrap-wrap h6T my-2 border-b border-0">
            <p style="white-space:nowrap" class="text-primary">{{returnLag(21)}}</p>
            <p class="text-left w-100 pl-5 ">
              {{ order.bank_no }}
              <button class="btn" v-clipboard:success="onCopy" v-clipboard:copy="order.bank_no">{{ returnLag(13) }}</button>
            </p>
          </h6>
        </div>
        <div  class="col-12 d-flex liss" v-if="!order.bank_from">
          <h6 class="text-right d-flex flex-wrap-wrap h6T my-2 mt-0 border-b">
            <p style="white-space:nowrap" class="text-primary"></p>
            <p class="text-left w-100 pl-5 pb-1">
              <vue-qrcode :margin="1" :value="order.bank_no" :width="150" />
            </p>
          </h6>
        </div>
        <div  class="col-12 d-flex liss">
          <h6 class="text-right d-flex flex-wrap-wrap h6T my-2 border-b">
            <p style="white-space:nowrap" class="text-primary">{{returnLag(14)}}</p>
            <p class="text-left w-100 pl-5 ">
              {{ order.expired }}
            </p>
            </h6>
        </div>
      </div>
      </div>
      <div class="imgWrap"  v-if="timeMsg == '' && bankName" >
        <img :src="'/'+bankName+'/1.png'" alt=''>
        <img :src="'/'+bankName+'/2.png'" alt=''>
        <img :src="'/'+bankName+'/3.png'" alt=''>
        <img :src="'/'+bankName+'/4.png'" alt=''>
        <img :src="'/'+bankName+'/5.png'" alt=''>
        <img :src="'/'+bankName+'/6.png'" alt=''>
        <img :src="'/'+bankName+'/7.png'" alt=''>
        <img v-if="bankName != 'ok'" :src="'/'+bankName+'/8.png'" alt=''>
      </div>
      <div v-if="timeMsg != ''" class="timeMsg">
        <h4 class="tit1">{{timeMsg}}</h4>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import VueQrcode from 'vue-qrcode'
export default {
  components: {
    VueQrcode,
  },
  data() {
    return {
      bankName:"",
      order:{},
      timeout: "",
      timeMsg: "",
      currentMsg:"vnd",
      twd:{
        "1":  "訂單成立",
        "2":  "請於時間內使用您選擇的付款方式進行付款！",
        "3":  "本次交易明細如下 ! ",
        "4":  "單位",
        "5":  "新臺幣 (元)",
        "6":  "訂單編號",
        "7":  "商店編號",
        "8":  "消費者ID",
        "9":  "實際繳費金額",
        "10": "付款方式",
        "11": "銀行代碼",
        "12": "ATM繳費帳號",
        "13": "複製帳號",
        "14": "繳費截止日期",
        "16": "注意事項",
        "17": "請依訂單金額繳納，切勿重複繳款，謝謝合作",
        "18": "晚上 12 點至凌晨 1 點之間為銀行固定維護時間，如於此期間進行轉帳，將於凌晨 1 點後入帳。",
        "19": "若使用ATM櫃員機，可選擇轉帳 / 轉出 ( 繳費單筆上限3萬元 ) 或繳費 ( 無上限3萬元限制 ) 之功能按鈕；若為使用第一銀行ATM櫃員機，請選擇「繳費」按鈕。",
        "20": "適用【繳費】功能之銀行ATM櫃員機：玉山銀行、臺灣銀行、中國信託、土地銀行、富邦銀行、第一銀行、華南銀行、臺新銀行、彰化銀行。(無上限3萬元限制)",
        "21": "繳費代碼",
        "22": "超商代收-代碼的繳費期限為2天，請務必於期限內進行繳款。",
        "23": "例如：8月1日的20:15購買商品，繳費期限為2天，表示8月3月的23:59:59前您須前往繳費。",
        "24": "手續費由賣家負擔(從當筆交易款項中扣除)，提醒您！超商店員不會在結帳時另外收手繳費。",
        "25": "請抄下此組至 7-11 繳費",
        "26": "越南文",
        "27": "超商付款",
        "28": "充值金額"
      },
      vnd:{
            "1": "Đơn hàng được thiết lập",
            "2": "Vui lòng sử dụng phương thức thanh toán bạn đã chọn để thanh toán trong thời hạn ",
            "3": "Chi tiết của giao dịch này như sau ",
            "4": "đơn vị",
            "5": "Đô la Đài Loan mới (Nhân dân tệ)",
            "6": "Số thứ tự hoá đơn ",
            "9": "Số tiền thanh toán",
            "10": "phương thức thanh toán",
            "11": "Mã ngân hàng",
            "12": "Tài khoản thanh toán ATM",
            "13": "Sao chép",
            "14": "Thời hạn thanh toán",
            "16": "Lưu ý ( chú ý)",
            "17": "Quý khách vui lòng thanh toán theo số lượng đơn hàng, vui lòng không lặp lại thao tác thanh toán nhiều lần, xin cảm ơn quý khách đã hợp tác",
            "18": "Thời gian bảo trì cố định của ngân hàng là từ 00h đến 1h , nếu bạn chuyển khoản trong khoảng thời gian này thì sau 1h sẽ được ghi có.",
            "19": "Nếu bạn sử dụng máy rút tiền ATM, bạn có thể chọn nút chức năng chuyển tiền / chuyển ra (hạn mức thanh toán một lần là 30.000 nhân dân tệ) không giới hạn số lần giao dịch Nếu bạn đang sử dụng máy rút tiền ATM của ngân hàng đầu tiên, vui lòng chọn nút 'Thanh toán.'",
            "21": "Mã thanh toán",
            "25": "Vui lòng copy mã này đến cửa hàng tiện lợi eleven 7-11 - family marth để thanh toán",
            "26": "Tiếng Việt",
            "27":' Thanh toán siêu kinh doanh',
            "28": "Nạp tiền"
        },
    };
  },
  computed: {},
  methods: {
    returnLag(key){
      return this[this.currentMsg][key]
    },
    onCopy(){
      this.$message.success('success')
    },
    getOrder() {
      axios
        .get(
          `${process.env.VUE_APP_DEFAULT_SRC}query?transaction_id=${this.$route.query.transaction_id}`
        )
        .then(res => {
          if (res.data.code == 0) {
            this.order = res.data.data;
            if(res.data.data.bank_name=='' || res.data.data.bank_name.toLocaleLowerCase() == '711'.toLocaleLowerCase() || res.data.data.bank_name.toLocaleLowerCase() == 'OK'.toLocaleLowerCase() || res.data.data.bank_name.toLocaleLowerCase() == 'Family'.toLocaleLowerCase()) {
             if(res.data.data.bank_name=='') {
                this.bankName = '711'
             }else {
               this.bankName = res.data.data.bank_name.toLocaleLowerCase()
             }
            }else {
              this.bankName = ''
            }
          } else {
            this.timeMsg = res.data.message;
            clearInterval(this.timeout);
          }
        });
    }
  },
  created() {
    document.title = 'Thu ngân'
    this.getOrder();
    this.timeout = setInterval(() => this.getOrder(), 60000);
  }
};
</script>
<style lang="scss">
  .imgWrap {
    display: flex;
    flex-direction: column;
    img {
      max-width: 1000px;
      width: 100%;
    }
  }
  
body {
  background-color: #EBEFF0 !important;
}
.wrap {
  font-family: 新細明體 !important;
  width: 100%;
  min-height: 90vh;
  border-radius: 10px;
  align-items: center;
  display: flex;
  justify-content: center;
}
p {
  color:black;
  font-size: 16px;
  word-break:break-all;
}
.cards {
  width: 100%;
  box-shadow: 1;
  background-color: #fff;
  display: block;
  padding: 30px 50px;
  border-radius: 10px;
  margin-bottom: 30px;
  -webkit-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
  -moz-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
  box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
}
.liss:nth-child(even){
  // justify-content: flex-end;
}
.liss:nth-child(even){
  justify-content: flex-start  !important;
  h6 {
  justify-content: space-between  !important;
  width: 100%;
    flex-direction: row !important;
  }
}
  .h6T {
  justify-content: space-between  !important;
  width: 100%;
    // flex-direction: column;
    p {
      // text-align: left;
      margin-bottom: 0;
    }
  }
@media(max-width:768px) {
.liss:nth-child(even){
  justify-content: flex-start  !important;
  h6 {
  justify-content: space-between  !important;
  width: 100%;
    flex-direction: row !important;
  }
}
  .h6T {
  justify-content: space-between  !important;
  width: 100%;
    // flex-direction: column;
    p {
      // text-align: left;
      margin-bottom: 0;
    }
  }
  .cards {
    padding: 20px
  }
}
.tit1 {
  margin-bottom: 30px;
  border-bottom: 3px solid #007bff;
  padding-bottom: 20px;
}

h6 {
  line-height: 2;
}
.inputWrap {
  border-top: 3px solid #CCC;
  border-bottom: 3px solid #CCC;
}
.border-b {
  width: 100%;
  border-bottom: 1px solid #CCC;
  p{
    &:first-child {
      width: 400px;
      text-align: left;
    }
  }
}
  .btn{
    padding: 5px;
    border-radius: 5px;
    min-width: 80px;
    color:white;
    background-color: #4669E7;
    float:right;
    margin-bottom:5px;
    &:hover{
      color:white;
    }
  }
  .lanWrap {
    display: flex;
    justify-content: flex-end;
    .lanBox {
      padding: 3px 5px;
      border: 1px solid black;
      border-radius: 3px;
      margin-left: 5px;
      margin-right: 5px;
      cursor: pointer;
      &.active {
        color:white;
        background-color: #4669E7;
        border: 1px solid gray;
      }
    }
  }
  .t1 {
    text-align: center;
  }
  .t2 {
    text-align: right;
  }
  @media(max-width:500px) {
    .t1 {
      text-align: left;
    }
    .t2 {
      text-align: center;
    }
    .tit1 {
      font-size: 24px;
    }
    .border-b {
      flex-wrap: wrap;
      p{
        &:last-child {
          padding-left: 0 !important;
        }
      }
    }
  }
  .noQrcode {
    width: 150px;
    margin-top: -20px;
  }
</style>